import React from 'react'
import Svg from './Svg'
export const SvgMeasureArea = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 3V0H3v3H0v9h3v12h9V12h12V3H12zm-9 7.5H1.5v-6H3v6zM10.5 3h-3v1.5h3V6h-3v1.5h3V9h-3v1.5h3V12h-3v1.5h3V15h-3v1.5h3V18h-3v1.5h3v3h-6v-21h6V3zm12 7.5H21v-3h-1.5v3H18v-3h-1.5v3H15v-3h-1.5v3H12v-6h10.5v6z" />
  </Svg>
))
SvgMeasureArea.isIcon = true
export default SvgMeasureArea
